import { useEffect, useState } from 'react';

export default function CountdownTimer({ endsAt, size = 140, onExpire }) {
  const [remaining, setRemaining] = useState(0);
  const [total, setTotal] = useState(60);

  useEffect(() => {
    if (!endsAt) return;
    const end = new Date(endsAt).getTime();
    const start = Date.now();
    const dur = Math.max(1, Math.round((end - start) / 1000));
    setTotal((prev) => Math.max(prev, dur));
    let expired = false;
    const tick = () => {
      const r = Math.max(0, Math.round((end - Date.now()) / 1000));
      setRemaining(r);
      if (r === 0 && !expired) {
        expired = true;
        onExpire && onExpire();
      }
    };
    tick();
    const id = setInterval(tick, 250);
    return () => clearInterval(id);
  }, [endsAt, onExpire]);

  const pct = Math.min(1, remaining / total);
  const r = (size - 14) / 2;
  const c = 2 * Math.PI * r;
  const dash = c * pct;
  const critical = remaining <= 10;

  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="countdown-timer">
      <svg width={size} height={size} className={critical ? 'animate-pulse' : ''}>
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#1E293B" strokeWidth="10" fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={r}
          stroke={critical ? '#DC2626' : remaining <= 20 ? '#FACC15' : '#10B981'}
          strokeWidth="10" fill="none" strokeLinecap="round"
          strokeDasharray={`${dash} ${c}`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: 'stroke-dasharray 0.25s linear, stroke 0.3s' }}
        />
      </svg>
      <div className="absolute inset-0 grid place-items-center">
        <div className="text-center">
          <div className={`font-mono-num font-bold ${critical ? 'text-rose-400' : 'text-white'}`}
               style={{ fontSize: size * 0.28 }}>{remaining}</div>
          <div className="text-[10px] uppercase tracking-widest text-slate-400">sec</div>
        </div>
      </div>
    </div>
  );
}
